import { Redirect, RouteComponentProps, Router } from '@reach/router';
import React, { ComponentType } from 'react';
import { Editor } from './detail/editor/editor.component';
import { List } from './list/list.component';

export const CompanyRoutes: ComponentType<RouteComponentProps> = (props) => {
  return (
    <>
      <Router className="router">
        <List path="list" />
        <Editor path=":id/edit-company" />
        <Editor path="create-company" />
        <Redirect noThrow from="/" to="list" />
      </Router>
    </>
  );
};
